export default __webpack_public_path__ + "static/media/projects.39c20078.svg";